import React from 'react'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import style from './index.module.scss'

interface ClassNames {
  item?: string
  childWrapper?: string
  icon?: string
}

interface UtilityBoxItemProps {
  icon?: string
  children?: React.ReactNode
  classNames?: ClassNames
  role?: string
}

const UtilityBoxItem: React.FunctionComponent<
  React.PropsWithChildren<UtilityBoxItemProps>
> = ({ icon, children, classNames: customClassNames = {}, ...iconOptions }) => (
  <div className={classNames(style.UtilityBoxItem, customClassNames.item)}>
    {icon && (
      <Icon
        className={classNames(style.icon, customClassNames.icon)}
        type={icon}
        {...iconOptions}
      />
    )}
    <div
      className={classNames(style.childWrapper, customClassNames.childWrapper)}
    >
      {children}
    </div>
  </div>
)

export default UtilityBoxItem
